import { z } from "zod";

export interface AddUserFormData {
    nickname: string;
    email: string;
    password?: string;
    password_confirmation?: string;
    country_id?: number;
    language_id?: number;
    currency_id?: number;
}

export const buildAddUserFormSchema = (showPasswordFields: boolean) =>
    z
        .object({
            nickname: z.string().min(1, "forms.general-validation.nickname_required"),
            email: z
                .string()
                .min(1, "forms.general-validation.email_required")
                .email("forms.general-validation.email_invalid"),
            country_id: z.number().optional(),
            language_id: z.number().optional(),
            currency_id: z.number().optional(),
            password: showPasswordFields
                ? z.string().min(1, "forms.general-validation.password_required")
                : z.string().optional(),
            password_confirmation: showPasswordFields
                ? z.string().min(1, "forms.general-validation.password_confirmation_required")
                : z.string().optional(),
        })
        .refine((values) => !showPasswordFields || values.password === values.password_confirmation, {
            message: "forms.general-validation.passwords_dont_match",
            path: ["password_confirmation"],
        });
